import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=38542c84&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=38542c84&scoped=true&lang=scss&"
import style2 from "./DashboardLayout.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38542c84",
  null
  
)

export default component.exports